/** Paleta editorial Pulse — debe coincidir con shared/imagegen/palette.py RANK_PALETTE. */
const RANK_PALETTE = [
  ["0E9FEE", "003F28"],
  ["003020", "FFFFFF"],
  ["00A443", "003F28"],
  ["D68010", "003F28"],
  ["F3ECE7", "003F28"],
  ["0E9FEE", "003F28"],
  ["D68010", "003F28"],
  ["003020", "FFFFFF"],
  ["FFF5EC", "003F28"],
  ["0E9FEE", "003F28"],
  ["003020", "FFFFFF"],
  ["00A443", "003F28"],
  ["D68010", "003F28"],
] as const;

const COLORED_SUFFIX =
  /^(?<base>.+\/)(?<id>\d+)_(?<primary>[0-9A-Fa-f]{6})_(?<secondary>[0-9A-Fa-f]{6})(?<ext>\.png.*)$/i;

function rankPaletteTokens(slotIndex: number): readonly [string, string] {
  const idx = Math.min(Math.max(slotIndex, 0), RANK_PALETTE.length - 1);
  return RANK_PALETTE[idx]!;
}

export function rewritePulseImageUrl(
  imageUrl: string | null | undefined,
  slotIndex: number,
): string | null {
  if (!imageUrl?.trim()) return null;
  const [primary, secondary] = rankPaletteTokens(slotIndex);
  const match = imageUrl.trim().match(COLORED_SUFFIX);
  if (!match?.groups?.base || !match.groups.id || !match.groups.ext) {
    return imageUrl;
  }
  return `${match.groups.base}${match.groups.id}_${primary}_${secondary}${match.groups.ext}`;
}
